import { JSX, ReactNode, createContext, useContext } from 'react';
import { SubmitUserSettingsRequest, UserSettingsResponse, UserSetting } from 'vopay';
import useUserSettings, { DEFAULT_SUB_ACCOUNT_BALANCE_DISPLAY } from '@/hooks/useApi/useUserSettings';

type UserSettings = {
  userSettings: UserSetting;
  submitUserSettings: (userSettings: SubmitUserSettingsRequest) => Promise<UserSettingsResponse>;
};

export const UserSettingsContext = createContext<UserSettings>({
  userSettings: {
    timezone: 'UTC',
    SubAccountBalanceDisplay: DEFAULT_SUB_ACCOUNT_BALANCE_DISPLAY,
  },
  submitUserSettings: async () => ({
    Success: false,
    ErrorMessage: '',
    Username: '',
    Settings: {
      timezone: 'UTC',
      SubAccountBalanceDisplay: DEFAULT_SUB_ACCOUNT_BALANCE_DISPLAY,
    },
  }),
});

export const UserSettingsProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const { userSettings, submitUserSettings } = useUserSettings();

  return (
    <UserSettingsContext.Provider
      value={{
        userSettings,
        submitUserSettings,
      }}
    >
      {children}
    </UserSettingsContext.Provider>
  );
};

export const useUserSettingsProvider = (): UserSettings => useContext(UserSettingsContext);
